import { useCallback } from 'react';
import { SendTeamsNotificationActionType, SendTeamsNotificationErrorType, SendTeamsNotificationInputDataType } from '../types';
import { stringRequired } from '../../utils/validations';

export const initialSendTeamsNotification: SendTeamsNotificationActionType = {
	webHookUrl: '',
	text: ''
};

export default function useSendTeamsNotification() {
	const validate = useCallback((values: {
		webHookUrl: string;
		text: string;
	}): {
		hasErrors(): boolean;
		errors: SendTeamsNotificationErrorType;
	} => {
		let hasErrors = false;
		const validations = {
			webHookUrl: [
				stringRequired(values.webHookUrl, 'This field is required'),
			],
			text: [
				stringRequired(values.text, 'This field is required'),
			]
		};

		const getError = (validation: Array<string | undefined>) => {
			const foundError = validation.find(item => item !== undefined) || null;
			if (foundError) {
				hasErrors = true;
			}
			
			return foundError || null;
		};

		return {
			hasErrors: () => hasErrors,
			errors: {
				webHookUrl: getError(validations.webHookUrl),
				text: getError(validations.text),
			}
		};
	}, []);

	const getValues = useCallback((data: SendTeamsNotificationActionType) => {
		if (!data) return null;
		return {
			webHookUrl: data.webHookUrl,
			templateMessage: data.text,
		};
	}, []);

	const loadValues = useCallback((data: SendTeamsNotificationInputDataType): SendTeamsNotificationActionType => {
		return {
			webHookUrl: data.webHookUrl,
			text: data.templateMessage
		};
	}, []);

	return {
		validate,
		getValues,
		loadValues
	};
}